import React,{useState,useEffect} from "react";

import { useDispatch } from "react-redux";

const RangeSliderColorAlpha = ({setSliderVal,showMarkerColor,sliderVal }) => {
  
  
  
    
       const dispatch = useDispatch();  
     const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
            {
              
              dispatch({type: "CURSOR",payload:true  });
          
              dispatch({type: "CURSORTEXT",payload:CursorText})
              dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
              dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
            }
             
            const handleMouseLeave = () => {
              
              dispatch({type: "CURSOR",payload:false})
          
              dispatch({type: "CURSORTEXT",payload:""})
          
              dispatch({type: "CURSORTEXTBG",payload:""})
              dispatch({type: "CURSORTEXTCOLOR",payload:""})
            
          
          }
            
       
  const [value, setValue] = useState();
     useEffect(()=>{
      setValue(sliderVal*10?sliderVal*10:5)
     },[])


     let rangeArr=[0,0.2, 0.4, 0.6, 0.8 , 1 ];
    return (
      <div className="range-slider-basic-two" >
        <input
          type="range"
          min={0}
          max={10}
          value={value}
          onChange={(e) => {setValue(e.target.value) ;setSliderVal(e.target.value/10)}}
          className="slider-basic-two" style={{background:value<5?"#f1f1f1":showMarkerColor,color:value<5?"#222":"#ccc",}}
        />
        <div className="marks">
        {rangeArr?.map((mark,index) => (
          <span onClick={() => {setValue(mark*10) ;setSliderVal(mark);}} 
            key={mark}  onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
            className={`mark-basic ${value === mark ? '' : ''}`}
            style={{ left: `${index*20}%` }}
          >
           <div style={{color:value<5?"#222":"#fff",position:"relative",zIndex:99}}> {mark} </div> 
          </span>
        ))}
      </div>{/* Marker that moves with thumb */}
  <div
    className={`mark-floating-two ${value ? 'active-basic-two' : ''}`}
    style={{
      left: `${(((value) /10) * 100)-(value<5?-4:9)}%`, overflow:"hidden"
    }}
  ><div style={{position:"absolute",top:0,left:0,right:0,bottom:0,background:showMarkerColor,zIndex:9}}> </div>
  <div style={{color:value<5?"#222":"#fff",position:"relative",zIndex:99}}>{value/10}</div>  
  </div>
          </div>
    );
  };
  export default RangeSliderColorAlpha;